import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { CloseOutlined, InfoCircleOutlined, LinkOutlined } from "@ant-design/icons";
import { useHidePlatformPricing } from "util/platformPricing";
import styles from "./style.module.scss";

export const SONIC_PROSPECT_LANDING_URL =
  "https://pivony.com/products/sonic-prospect?utm_source=app.pivony.com&utm_medium=console&utm_campaign=sonic-prospect-learn";

const dismissKey = (userId) => `pivony_sp_learn_dismissed_${userId || "anon"}`;

const ProductLearnBanner = ({ userId }) => {
  const { t } = useTranslation();
  const hidePricing = useHidePlatformPricing();
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(dismissKey(userId)) === "1";
    } catch (_) {
      return false;
    }
  });

  if (hidden) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(dismissKey(userId), "1");
    } catch (_) {}
    setHidden(true);
  };

  return (
    <div className={styles.learnBanner} role="note">
      <InfoCircleOutlined className={styles.learnBannerIcon} aria-hidden />
      <div className={styles.learnBannerText}>
        <strong>{t("sonic_prospect.learn_banner_title")}</strong>
        <span>
          {t(
            hidePricing
              ? "sonic_prospect.learn_banner_desc_sales"
              : "sonic_prospect.learn_banner_desc",
          )}
        </span>
      </div>
      <Button
        type="link"
        size="small"
        icon={<LinkOutlined />}
        href={SONIC_PROSPECT_LANDING_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.learnBannerLink}
      >
        {t("sonic_prospect.learn_banner_cta")}
      </Button>
      <button type="button" className={styles.learnDismiss} onClick={dismiss} aria-label={t("sonic_prospect.learn_dismiss")}>
        <CloseOutlined />
      </button>
    </div>
  );
};

export default ProductLearnBanner;
